import React , {useState} from 'react'
import { NavLink} from 'react-router-dom'
import {Logo} from '../../../assets/img'
import './header.scss'

function Index() {

    const [isActive , setActive] = useState(false) 

    return (
        <div className='header'>
            <div className='header-logo'>
                <img src={Logo} className='header-img' alt='' />

                <div className={`hamburger-menu ${isActive ? 'open' : ''}` } onClick={() => setActive(!isActive)}>
                    <div className='hamburger-btn' />
                </div>
            </div>

            <div className={`header-link ${isActive ? 'active' : '' }`}>

                <ul className={`list ${isActive ? 'active' : null }`}>
                    <li className='list-item'><NavLink to='/' exact className='link'activeClassName='active-link' onClick={() => setActive(!isActive)}>Home</NavLink></li>
                    <li className='list-item'><NavLink to='/about' className='link' activeClassName='active-link' onClick={() => setActive(!isActive)}>About Us</NavLink></li>
                    <li className='list-item'><NavLink to='/courses' className='link' activeClassName='active-link' onClick={() => setActive(!isActive)}>Courses</NavLink></li>
                    <li className='list-item'><NavLink to='/experts' className='link' activeClassName='active-link' onClick={() => setActive(!isActive)}>Experts</NavLink></li>
                    {/* <li className='list-item'><NavLink to='/get-in-touch' className='link' activeClassName='active-link' onClick={() => setActive(!isActive)}>Get In Touch</NavLink></li> */}
                    {/* <li className='list-item'><NavLink to='/blog' className='link' activeClassName='active-link' onClick={() => setActive(!isActive)}>Blog</NavLink></li>
                    <li className='list-item'><NavLink to='/training' className='link' activeClassName='active-link' onClick={() => setActive(!isActive)}>Training Request </NavLink></li> */}
                </ul>

            </div>
        </div>
    )
}

export default Index
